export const LOADER_STATUS = 'boilderplate/GSTR2A2BNEWCOMMON/LOADER_STATUS';
export const DEFAULT_ENTITY = 'boilderplate/GSTR2A2BNEWCOMMON/DEFAULT_ENTITY';
export const STORE_GSTIN_GSTR2A2BNEW = 'boilderplate/GSTR2A2BNEWCOMMON/STORE_GSTIN_GSTR2A2BNEW';
export const PROFILE_DATA = 'boilderplate/GSTR2A2BNEWCOMMON/PROFILE_DATA';
export const STORE_PERIOD = 'boilderplate/GSTR2A2BNEWCOMMON/STORE_PERIOD';
export const STORE_PERIOD_SINGLE = 'boilderplate/GSTR2A2BNEWCOMMON/STORE_PESTORE_PERIOD_SINGLERIOD';
export const SET_ENTITY_LIST = 'boilderplate/GSTR2A2BNEWCOMMON/SET_ENTITY_LIST';
export const IS_CHECKED_2A2B = 'boilderplate/GSTR2A2BNEWCOMMON/IS_CHECKED_2A2B';
export const ENTITY_LABEL = 'boilderplate/GSTR2A2BNEWCOMMON/ENTITY_LABEL';



